import { FiltersParams } from 'types/params';
import { SearchFilterMeta } from 'controllers/SearchController/types';
import keepFilterWithSmallerValue from './keepFilterWithSmallerValue';
import convertFilterToModifiersWithTotal from './convertFilterToModifiersWithTotal';

const getFilteredModifiersWithTotal = (
    total: number,
    params: FiltersParams,
    filterMeta?: SearchFilterMeta,
) => {
    const filtered = keepFilterWithSmallerValue(total, filterMeta);
    const modifiersWithTotal = convertFilterToModifiersWithTotal(
        filtered,
        params,
    );

    return modifiersWithTotal;
};

export default getFilteredModifiersWithTotal;
